type SearchIconProps = React.SVGProps<SVGSVGElement>;

const SearchIcon: React.FC<SearchIconProps> = (props) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="barcode-scan-mask"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path
        d="M6.69719 1C3.55552 1.00004 0.99992 3.56136 0.99992 6.73145C0.999995 9.90147 3.55557 12.4629 6.69719 12.4629C9.83883 12.4629 12.3944 9.90149 12.3945 6.73145C12.3945 3.56134 9.83888 1 6.69719 1Z"
        stroke="white"
        strokeWidth="2"
      />
      <rect fill="white" x="0" y="0" width="24" height="24" />
    </mask>
    <path
      d="M6.69719 1C3.55552 1.00004 0.99992 3.56136 0.99992 6.73145C0.999995 9.90147 3.55557 12.4629 6.69719 12.4629C9.83883 12.4629 12.3944 9.90149 12.3945 6.73145C12.3945 3.56134 9.83888 1 6.69719 1Z"
      stroke="#424242"
      strokeWidth="2"
    />
    <rect
      width="1.5"
      height="6.15475"
      transform="matrix(-0.705308 0.708901 0.705309 0.7089 11.7055 10.0969)"
      fill="#424242"
    />
  </svg>
);
export default SearchIcon;
